import React from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";
import fractionToInt from "../../util/fractionToInt";
import { UnitObj } from "../../util/quoteCartStorage";
import { convertDecimalToFraction } from "../../util/formulas/convertDecimalToFraction";

function useHeightSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorHeight = useStore((state) => state.quote.height);
  const doorHeightFraction = useStore((state) => state.quote.heightFraction);

  const windowHeight = useStore((state) => state.quote.comboWindowHeight);
  const windowHeightFraction = useStore(
    (state) => state.quote.comboWindowHeightFraction,
  );

  const handleError = useStore((state) => state.handleError);

  const errors = useStore((state) => state.errors);

  const showError = (unitType: string, overall: number) => {
    const msgHigh = "Height can not exceed";
    const msgLow = "Height must exceed";

    if (unitType === "Door") {
      const max = 122.5;
      const min = 72;

      if (overall > max) {
        handleError(
          "heightErr",
          `${msgHigh} ${convertDecimalToFraction(max)}"`,
        );
      } else if (overall < min) {
        handleError(
          "heightErr", 
          `${msgLow} ${convertDecimalToFraction(min)}"`
        );
      }else{
        handleError("heightErr", "")
      }

      const overallHeightWindow = fractionToInt(
        windowHeight || "",
        windowHeightFraction,
      );
      const maxWindowHeight = 72;

      if(overall - overallHeightWindow < 40){
        addToQuote({ handleHeight: "31\"" })
      }else{
        addToQuote({ handleHeight: "36\"" })
      }

      if (overallHeightWindow > maxWindowHeight) {
        handleError(
          "heightErrComboWindow",
          `${msgHigh} ${convertDecimalToFraction(maxWindowHeight)}"`,
        );
      }else{
        handleError(
          "heightErrComboWindow",
          "",
        );
      }
      return;
    }

    // if unit type is window
    const overallHeightDoor = fractionToInt(
      doorHeight || "",
      doorHeightFraction,
    );
    const max = 72;
    const min = 26;

    if(overallHeightDoor - overall < 40){
      addToQuote({ handleHeight: "31\"" })
    }else{
      addToQuote({ handleHeight: "36\"" })
    }

    if (overall > max) {
      handleError(
        "heightErrComboWindow",
        `${msgHigh} ${convertDecimalToFraction(max)}"`,
      );
    } else if (overall < min) {
      handleError(
        "heightErrComboWindow",
        `${msgLow} ${convertDecimalToFraction(min)}"`,
      );
    }else{
      handleError(
        "heightErrComboWindow",
        ""
      );
    }
  };

  const handleHeightChangeDoor = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: Partial<UnitObj> = {};

    if (!num) update["height"] = "";
    else update["height"] = `${num}`;

    addToQuote(update, "height");

    if (num) {
      const overallHeight = fractionToInt(value, doorHeightFraction);
      showError("Door", overallHeight);
    }
  };

  const handleHeightChangeWindow = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: Partial<UnitObj> = {};

    if (!num) update["comboWindowHeight"] = "";
    else update["comboWindowHeight"] = `${num}`;

    addToQuote(update, "comboWindowHeight");

    if (num) {
      const overallHeight = fractionToInt(value, windowHeightFraction);
      showError("Window", overallHeight);
    }
  };

  const handleFractionChangeDoor = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ heightFraction: "" });

    addToQuote({
      heightFraction: value,
    });

    const overallHeight = fractionToInt(doorHeight, value);
    showError("Door", overallHeight);
  };

  const handleFractionChangeWindow = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ comboWindowHeightFraction: "" });

    addToQuote({
      comboWindowHeightFraction: value,
    });

    const overallHeight = fractionToInt(windowHeight || "", value);
    showError("Window", overallHeight);
  };

  return {
    handleHeightChangeDoor,
    handleFractionChangeDoor,
    handleFractionChangeWindow,
    handleHeightChangeWindow,
    heightErrDoor: errors.heightErr,
    heightErrWindow: errors.heightErrComboWindow,
    doorHeight,
    windowHeight,
    doorHeightFraction,
    windowHeightFraction,
  };
}

export default useHeightSelection;
